"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSteps = void 0;
function normalize(n, step) {
    if (step === void 0) { step = 5; }
    var x = n % step;
    if (x == 0)
        return Math.round(n);
    if (x < 2.5)
        return Math.round(n - x);
    return Math.round(n + (step - x));
}
function getSteps(size) {
    if (size <= 1)
        return [100];
    var parts = 50 / (size - 1);
    var result = [];
    for (var i = 0; i < size; i++) {
        result.push(50 + normalize(i * parts));
    }
    return result;
}
exports.getSteps = getSteps;
//# sourceMappingURL=color-steps.js.map